import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Text from 'components/shared/DesignSystem/SlabTransferPortal/Text';
import UserSelect from 'components/projects/taskList/assign/search/UserSelect';
import AssignedUserItem from './AssignedUserItem';

// #region styled-components
const EmptyState = styled.div`
  text-align: center;
`;
const EmptyStateArrow = styled.svg`
  display: block;
  margin: var(--cc_size_spacing_m) auto var(--cc_size_spacing_s);
  fill: var(--cc_color_text_default);
`;
// #endregion

const AssignContent = ({ taskListId, assignedUsers, isEmpty }) => {
  const assignedUserIdsSet = new Set(assignedUsers.map((user) => user.id));

  let content = null;
  if (isEmpty) {
    content = (
      <EmptyState>
        <EmptyStateArrow
          width="10"
          height="20"
          viewBox="0 0 10 20"
          aria-hidden="true"
        >
          <path d="M6.17894 4.85869C6.17894 5.28962 6.17894 5.76363 6.17894 6.19456C6.13489 9.98671 6.04678 13.8219 6.00273 17.6141C6.00273 18.045 6.00273 18.4329 5.95868 18.8638C5.91462 19.424 5.78246 20.1135 5.03356 19.9842C4.72518 19.9411 4.37275 19.2947 4.3287 18.9069C4.15249 15.718 4.02033 12.5723 3.88817 9.38341C3.84411 8.65084 3.88816 7.91826 3.49168 7.1426C2.96304 8.00445 2.52251 8.9094 1.94981 9.72815C1.68549 10.116 1.02469 10.5469 0.628209 10.4607C-0.164753 10.2884 -0.0766462 9.42651 0.187675 8.90939C1.33306 6.32384 2.47845 3.69519 3.84411 1.19582C4.72518 -0.398608 6.04678 -0.398608 6.92785 1.19582C8.11729 3.30736 8.99836 5.59126 9.96754 7.78899C10.0997 8.04754 9.79133 8.47847 9.70322 8.82321C9.35079 8.69393 8.82215 8.69393 8.64594 8.43538C8.2054 7.91826 7.94108 7.22878 7.58865 6.62548C7.23622 5.9791 6.8838 5.33271 6.53137 4.72941C6.44327 4.8156 6.3111 4.85869 6.17894 4.85869Z" />
        </EmptyStateArrow>
        <Text size="s" as="p" color="subtle">
          <FormattedMessage
            id="Projects.taskList.assign.assignUserEmptyStateMessage"
            defaultMessage="Assigning checklists can increase completion rate by 17%."
            description="Message when there are no assigned users to this checklist"
          />
        </Text>
      </EmptyState>
    );
  } else {
    content = (
      <ul>
        {assignedUsers.map((assignedUser) => {
          return (
            <AssignedUserItem
              key={assignedUser.id}
              taskListId={taskListId}
              assignedUser={assignedUser}
            />
          );
        })}
      </ul>
    );
  }

  return (
    <>
      <UserSelect
        taskListId={taskListId}
        assignedUserIdsSet={assignedUserIdsSet}
      />
      {content}
    </>
  );
};

AssignContent.propTypes = {
  isEmpty: PropTypes.bool.isRequired,
  assignedUsers: PropTypes.array.isRequired,
  taskListId: PropTypes.string.isRequired,
};

export default AssignContent;
